import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import Login from '@/components/Login'
import Home from '@/components/Home'
import ImportHistory from '@/components/ImportHistory'
import ForgotPassword from '@/components/ForgotPassword'
import ResetPassword from '@/components/ResetPassword'
import BrandSettings from '@/components/BrandSettings'
import VendorSettings from '@/components/VendorSettings'
import LanguagePreference from '@/components/LanguagePreference'
import ConsultOurExperts from '@/components/ConsultOurExperts'
import SendingFormIsSuccess from '@/components/SendingFormIsSuccess'
import LoginTwoFactor from '@/components/LoginTwoFactor'
import LoginTwoFactorHelp from '@/components/LoginTwoFactorHelp'

Vue.use(Router)
axios.defaults.withCredentials = true

const ifAuthenticated = (to, from, next) => {
  
    axios.post(`${process.env.API_URL}/checkAuth`,this.form)
    .then(response => {
        console.log("checkAuth response")
        console.log(response)
        
        if (response.data.status.code=='0') {
          next()
          return
        }
        next('/login')
        
    })
    .catch(e => {
        console.log("checkAuth error")
        console.log(e)
    })
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/importHistory',
      name: 'ImportHistory',
      component: ImportHistory,
      beforeEnter:ifAuthenticated
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/forgotPassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/resetPassword',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/brandSettings',
      name: 'BrandSettings',
      component: BrandSettings
    },
    {
      path: '/vendorSettings',
      name: 'VendorSettings',
      component: VendorSettings
    },
    {
      path: '/languagePreference',
      name: 'LanguagePreference',
      component: LanguagePreference
    },
    {
      path: '/consultOurExperts',
      name: 'ConsultOurExperts',
      component: ConsultOurExperts
    },
    {
      path: '/sendingFormIsSuccess',
      name: 'SendingFormIsSuccess',
      component: SendingFormIsSuccess
    },
    {
      path: '/loginTwoFactor',
      name: 'LoginTwoFactor',
      component: LoginTwoFactor
    },
    {
      path: '/loginTwoFactorHelp',
      name: 'LoginTwoFactorHelp',
      component: LoginTwoFactorHelp
    }
  ],
  mode:"history"
})



// WEBPACK FOOTER //
// ./src/router/index.js